import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { stopLoading } from "./application";
import { adyenComponentSessionDataCache } from '../utils/storage/localStorage';

declare const window: any;

export const adyenLinkApi = createApi({
    reducerPath: 'adyenLinkApi',
    baseQuery: fetchBaseQuery({
        baseUrl: window.Config?.LAMBDA_ADYENLINK ?? "https://npr-adyen.api.pens.com/v1/createPaymentLink",
        prepareHeaders: (headers) => {
            headers.set(window.Config?.NP_API_KEY_HEADER_NAME ?? "x-api-key", window.Config?.NP_API_KEY_CLIENT_JS ?? "NSjMi38PBJ6s1rvNMA9FKO6FRn2iDd95bEDoaij8")
            return headers
        },
    }),

    tagTypes: ['Adyen'],
    endpoints: (builder) => ({
        adyenLink: builder.mutation({
            query: (data) => ({
                url : ``,
                method: 'POST',
                body: data
            }),
            async onQueryStarted(obj, { dispatch, getState, queryFulfilled }) {
                try{
                    const {data} = await queryFulfilled;
                    return data;
                }
                catch(error){
                    console.log(error);
                } finally {
                    dispatch(stopLoading())
                }
            },
        }),
    }),
})

export const adyenApi = createApi({
    reducerPath: 'adyenApi',
    baseQuery: fetchBaseQuery({
        baseUrl: window.Config?.LAMBDA_ADYEN ?? "https://npr-adyen.api.pens.com/",
        prepareHeaders: (headers) => {
            headers.set(window.Config?.NP_API_KEY_HEADER_NAME ?? "x-api-key", window.Config?.NP_API_KEY_CLIENT_JS ?? "NSjMi38PBJ6s1rvNMA9FKO6FRn2iDd95bEDoaij8")
            return headers
        },
    }),
    tagTypes: ['Adyen'],
    endpoints: (builder) => ({
        getSessionData: builder.mutation({
            async queryFn(data, {dispatch}, _extraOptions, baseQuery): Promise<any> {
                const cartId = data.id;
                const version = data.version;
                const cachedSessionData = adyenComponentSessionDataCache.get(cartId, version);
                if (cachedSessionData) {
                    return { data: cachedSessionData };
                }
                const response: any = await baseQuery({
                    url: 'v1/getSessionData',
                    method: 'POST',
                    body: data
                });
                const obj = {
                    id: response?.data?.id,
                    sessionData: response?.data?.sessionData
                };
                adyenComponentSessionDataCache.set(obj, cartId, version);
                return { data: obj };
            },
            async onQueryStarted(obj, { dispatch, getState, queryFulfilled }) {
                try{
                    await queryFulfilled;
                }
                catch(error){
                    console.log(error);
                    throw error;
                } finally {
                    dispatch(stopLoading())
                }
            },
        }),
        submitPayments: builder.mutation({
            async queryFn(data, {dispatch}, _extraOptions, baseQuery): Promise<any> {
                const response: any = await baseQuery({
                    url: 'v1/submitPayments',
                    method: 'POST',
                    body: data
                });
                return response
            },
            async onQueryStarted(obj, { dispatch, getState, queryFulfilled }) {
                try{
                    await queryFulfilled;
                }
                catch(error){
                    console.log(error);
                    throw error;
                } finally {
                    dispatch(stopLoading())
                }
            },
        }),
        checkout: builder.mutation({
            async queryFn(data, {dispatch}, _extraOptions, baseQuery): Promise<any> {
                const response: any = await baseQuery({
                    url: 'v1/checkout',
                    method: 'POST',
                    body: data
                });
                return response
            },
            async onQueryStarted(obj, { dispatch, getState, queryFulfilled }) {
                try{
                    await queryFulfilled;
                }
                catch(error){
                    console.log(error);
                    throw error;
                } finally {
                    dispatch(stopLoading())
                }
            },
        }),
    }),
})

export const { useAdyenLinkMutation } = adyenLinkApi;
export const { useGetSessionDataMutation, useSubmitPaymentsMutation, useCheckoutMutation } = adyenApi;